export const formatNumberToVndCurrency = inputValue => {
  return `${inputValue.toLocaleString()}đ`;
};
